import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import BottomNav from './BottomNav';
import { useScrollRestoration } from '@/hooks/useScrollRestoration';
import { useEventProximityPing } from '@/hooks/useEventProximityPing';

export default function AppLayout(): React.ReactElement {
  useScrollRestoration();
  const { isTracking } = useEventProximityPing();
  const location = useLocation();

  // Full-bleed surfaces own their own bottom padding via internal anchors
  // (action rails, sticky inputs). pb-20 here would create a dead band
  // beneath them. Other pages keep the 80px reserve so content doesn't
  // slip behind the floating tab bar.
  const FULL_BLEED_ROUTES = ['/updates', '/cleo', '/ark'];
  const isFullBleed = FULL_BLEED_ROUTES.includes(location.pathname);

  return (
    <div className="min-h-screen">
      <div className={`relative app-layout-content${isFullBleed ? '' : ' pb-20'}`}>
        <Outlet />
      </div>
      {/* Subtle GPS tracking indicator — shows when pinging location for upcoming event */}
      {isTracking && (
        <div className="absolute bottom-[5.5rem] left-1/2 -translate-x-1/2 z-40 flex items-center gap-1.5 bg-black/80 backdrop-blur-sm rounded-full px-3 py-1">
          <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
          <span className="text-[10px] text-white/50 font-medium">Location active</span>
        </div>
      )}
      <BottomNav />
    </div>
  );
}
